import { useEffect, useRef } from 'react';

export const useInterval = (callback: () => void, delay: number | null) => {
  const savedCallback = useRef<() => void>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay === null) {
      return;
    }

    const executable = () => {
      if (savedCallback.current) {
        savedCallback.current();
      }
    };

    const intervalId = setInterval(executable, delay);

    return () => clearInterval(intervalId);
  }, [delay]);
};
